<h2 class="app-dialog-title">
  <ng-content></ng-content>
</h2>
